import { DefaultLayout as Layout } from '../../../layouts/Default/DefaultLayout';
import { UserEnableLogin } from '../../../components/user/UserEnableLogin/UserEnableLogin';

export const UserEnableLoginPage = () => {
  return (
    <Layout>
      <h1 id="primaryPageTitle" className="d-inline">
        Add New User
      </h1>
      <UserEnableLogin />
    </Layout>
  );
};
